// extracted by mini-css-extract-plugin
export default {"searchWrapper":"Search_searchWrapper__Oto-i","searchInput":"Search_searchInput__WaQv3","searchIcon":"Search_searchIcon__VJd-v","cancel":"Search_cancel__pNb8b"};